<p-drawer [(visible)]="visible" position="right" [modal]="false" (onHide)="onInboxDrawerHide()">
  <ng-template #header>
    <div class="flex flex-col gap-2">
      <div class="flex flex-row items-center justify-between w-full">
        <div class="text-lg font-bold pr-4">Inbox</div>
        <p-selectbutton size="small" [options]="['Unread', 'All']" [(ngModel)]="inboxFilter" (ngModelChange)="onInboxFilterChange($event)"></p-selectbutton>
      </div>
    </div>
  </ng-template>
  <div class="flex flex-col gap-2 w-full pt-2">
    @if(inboxMessages().length === 0) {
      <div class="flex flex-row items-center justify-center">
        <div class="text-md">No messages</div>
      </div>
    }
    @for(message of inboxMessages(); track message.id) {
      <p-overlaybadge [badgeDisabled]="message.status !== 'UNREAD'">
        <div class="flex flex-col gap-2 w-full shadow-md p-2 rounded-lg dark:border-surface-700  dark:bg-surface-800">
          <div class="flex flex-row items-center justify-between">
            <div class="text-sm">{{message.title}}</div>
            <!-- <div class="text-xs">{{message.created_at | dateToNow:'medium'}}</div> -->
          </div>
          <div class="flex flex-row items-center justify-between">
            <div class="text-sm line-clamp-2 overflow-hidden text-ellipsis">{{message.description}}</div>
          </div>
          <div class="flex flex-row items-center justify-between">
            @if(message.action_key && message.action_key === 'VIEW_ORG_INVITATION') {
              <p-button [raised]="true" [text]="true" size="small" (click)="onClickMessage(message)">{{message.action_label || 'View'}}</p-button>
            } @else if (message.action_path) {
              <p-button [raised]="true" [text]="true" size="small" (click)="onClickMessage(message)">{{message.action_label || 'View'}}</p-button>
            } @else {
              <div></div>
            }
            @if(message.status === 'UNREAD') {
              <p-button severity="info" [text]="true" size="small" (click)="inboxService.markAsRead(message)">Mark as Read</p-button>
            } @else if (message.status === 'READ') {
              <p-button severity="info" [text]="true" size="small" (click)="inboxService.archiveMessage(message)">Archive</p-button>
              <p-button severity="warn" icon="pi pi-trash" [text]="true" size="small" (click)="inboxService.deleteMessage(message)"></p-button>
            }
          </div>
        </div>
      </p-overlaybadge>
    }
  </div>
  <ng-template #footer>
    <div class="flex flex-row gap-2 items-center justify-between">
      <p-button [text]="true" size="small" label="Mark All as Read" (click)="inboxService.markAllAsRead()"></p-button>
      @if(inboxFilter() === 'All') {
        <p-button [text]="true" size="small" label="Delete All" (click)="inboxService.markAllAsArchived()"></p-button>
      }
    </div>
  </ng-template>
</p-drawer>